import hash from '@emotion/hash';

const cache = new Map();

/**
 * Loads a font from a given URL and caches the result. Avoids duplicate requests for the same font.
 *
 * @param url The URL of the font file to load.
 * @param weight The font weight to use (e.g., '400', '400 600').
 */
export function loadFont(url: string, weight: string) {
  const key = `${url}::${weight}`;
  const cached = cache.get(key);

  if (cached) {
    return cached;
  }

  const family = `WorkspaceFont_${hash(key)}`;
  const face = new FontFace(family, `url(${url})`, { weight, display: 'swap' });

  // Cache the promise, not result. Avoids waiting for a response in order to cache the request.
  const promise = face
    .load()
    .then(() => {
      document.fonts.add(face);
      return family;
    })
    .catch((err) => {
      console.error(`Failed to load font from ${url}:`, err);
      cache.delete(key);
      throw err;
    });

  cache.set(key, promise);

  return promise;
}
